import React from 'react'
import { Link } from 'react-router-dom'

const ExportButton = (props) => {
    return (
        <button
            type="button"
            className="mr-8 text-lg font-bold btn-red-border border text-[#C00000] px-3"
            onClick={props.onClick}
        >
            <span className="text-lg text-red font-semibold tracking-normal">
                {props.text}
            </span>
        </button>
    )
}
export default ExportButton;